module.exports = __webpack_public_path__ + "img/light-Path 24 Copy@3x.366ec5b5.png";